export const getters = {
    getManageEnrolmentDownloadManagerData: state => {
        return state.manageEnrolmentDownloadManagerData
    },
    getAPIError: state => state.APIError
};